





























import Vue, { PropType } from 'vue';
import { v4 } from 'uuid';

export default Vue.extend({
  name: 'GPriceForm',
  props: {
    isLabel: { type: Boolean as PropType<boolean>, default: true },
    isTag: { type: Boolean as PropType<boolean>, default: false },
    isPublic: { type: Boolean as PropType<boolean>, default: false },
    exclamation: { type: Array as PropType<string[]>, default: () => [] },
    label: { type: String as PropType<string>, required: true },
    value: { type: Number as PropType<number>, default: null },
    name: { type: String as PropType<string>, required: true },
    placeholder: { type: String as PropType<string>, default: '' },
    disabled: { type: Boolean as PropType<boolean>, default: false },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    rules: { type: String as PropType<string>, default: '' },
    min: { type: Number as PropType<number>, default: 0 },
    max: { type: Number as PropType<number>, default: 999999999 },
    // isSlim: { type: Boolean as PropType<boolean>, default: false },
  },
  computed: {
    vid(): string {
      return `${this.name}:${v4()}`;
    },
    innerValue: {
      get(): number {
        return this.value;
      },
      set(val: number): void {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    validate() {
      (this.$refs.gPriceFormProvider as any).validate();
    },
  },
});
